import { render, staticRenderFns } from "./ApiBalance.vue?vue&type=template&id=506991fc&scoped=true"
import script from "./ApiBalance.vue?vue&type=script&lang=js"
export * from "./ApiBalance.vue?vue&type=script&lang=js"
import style0 from "./ApiBalance.vue?vue&type=style&index=0&id=506991fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506991fc",
  null
  
)

export default component.exports